module.exports = __webpack_public_path__ + "static/media/pomegranate.0af8cd83.gif";